"use client";
import Link from "next/link";
import React from "react";
import { EffectFade, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { SwiperOptions } from "swiper/types";
import Image from "next/image";
import { ArrowIcons } from "../svg";
import { ifArabic } from "@/utils/language";
import { useTranslation } from "react-i18next";

const heroSliderData = [
  {
    id: 1,
    subtitle: "Al Hussein Technical University",
    subtitleAr: "جامعة الحسين التقنيّة",
    title: "Future ",
    titleAr: "المستقبل يبدأ هنا!",
    secondTitle: "Starts Here!",
    bgImg: "/assets/img/hero/hero-bg-1.webp",
    mobileImg: "/assets/img/hero/hero-bg-1-mobile.webp",
    alt: "Future Starts Here!",
  },
  {
    id: 2,
    title: "Excellence",
    titleAr: "تميّز",
    bgImg: "/assets/img/hero/hero-bg-2.webp",
    mobileImg: "/assets/img/hero/hero-bg-2-mobile.webp",
    alt: "Excellence!",
  },
  {
    id: 3,
    title: "Project-Based ",
    titleAr: "تعلّم قائم على المشاريع",
    secondTitle: "Learning",
    bgImg: "/assets/img/hero/hero-bg-3.webp",
    mobileImg: "/assets/img/hero/hero-bg-3-mobile.webp",
    alt: "Project-Based Learning",
  },
  {
    id: 4,
    title: "Employability",
    titleAr: "تشغيل",
    bgImg: "/assets/img/hero/hero-bg-4.webp",
    mobileImg: "/assets/img/hero/hero-bg-4-mobile.webp",
    alt: "Employability!",
  },
  {
    id: 5,
    title: "Innovation",
    titleAr: "ابتكار",
    bgImg: "/assets/img/hero/hero-bg-5.webp",
    mobileImg: "/assets/img/hero/hero-bg-5-mobile.webp",
    alt: "Innovation!",
  },
];

const slider_options: SwiperOptions = {
  slidesPerView: 1,
  effect: "fade",
  autoplay: {
    delay: 3500,
  },
  pagination: {
    el: ".tp-program-dot",
    clickable: true,
  },
};

export default function HeroAreaOne() {
  const { t } = useTranslation();
  const renderHeading = (item: any, index: number) => {
    const Tag = index === 0 ? "h1" : "h2";
    return (
      <>
        <Tag className="tp-hero-title">
          {ifArabic(item.titleAr || "", item.title || "")}{" "}
          {ifArabic("", item.secondTitle ? <br /> : "")}
          {ifArabic("", item?.secondTitle || "")}
        </Tag>
      </>
    );
  };
  return (
    <section className="tp-hero-area">
      <Swiper
        {...slider_options}
        modules={[EffectFade, Autoplay]}
        className="swiper tp-slider-active"
      >
        {heroSliderData.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div className="tp-hero-item">
              <Image
                src={item.bgImg}
                alt={item.alt}
                fill
                style={{ objectFit: "cover" }}
                className="tp-hero-bkg"
                priority
              />

              <div className="tp-hero-overlay" />

              <div className="container">
                <div className="row">
                  <div className="col-xxl-9 col-lg-11">
                    <div className="tp-hero-wrapper">
                      {item.subtitle && (
                        <span className="tp-hero-subtitle">
                          {ifArabic(item.subtitleAr, item.subtitle)}
                        </span>
                      )}
                      {renderHeading(item, index)}
                      <div className="tp-hero-btn">
                        <Link
                          className="tp-btn"
                          href="https://sis.htu.edu.jo/new/"
                          target="_blank"
                          aria-label="Apply Now"
                        >
                          {t("apply_now")}
                          <span>
                            {ifArabic(
                              <ArrowIcons.LeftArrow />,
                              <ArrowIcons.RightArrow />
                            )}
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
